import { Chip, Divider, Grid, makeStyles, Typography } from "@material-ui/core";
import { useEffect, useState } from "react";
import _ from "lodash";
import { useDataProvider } from "react-admin";
import styled from "styled-components";
import { useWindowDimensions } from "utils/dimensionHook";
import { getLocationWithoutSchool } from "./DraggableComponent";
import moment from "moment";

interface ILocationListComponent {
  selectedMarkers: any;
  waveType: string;
}

const useStyles = makeStyles({
  dragContent: {
    padding: "0px 5px",
  },
  dragContentTitleText: {
    fontSize: "13pt",
    fontWeight: 500,
    color: "#000000",
    marginTop: 13,
  },
  dragContentTitleTextSmallScreen: {
    fontSize: "11pt",
    fontWeight: 500,
    color: "#000000",
    marginTop: 13,
  },
  studentChipBox: {
    paddingLeft: 10,
  },
  studentChip: {
    margin: 5,
    backgroundColor: "#FFFFFF",
    color: "#6B6B6B",
    border: "1px solid #E3E3E3",
    borderRadius: 5,
  },
  studentChipWrapper: {
    marginBottom: 13,
  },
  arriveInputWrapper: {
    padding: "0px 5px",
  },
});

const LocationListComponent = ({
  selectedMarkers,
  waveType,
}: ILocationListComponent) => {
  const [tempMarkers, setTempMarkers] = useState<any>([]);
  const [levels, setLevels] = useState<ILevel[]>([]);

  const classes = useStyles();
  const provider = useDataProvider();
  const { width } = useWindowDimensions();

  useEffect(() => {
    const withoutSchool = getLocationWithoutSchool(waveType, selectedMarkers);

    setTempMarkers(withoutSchool);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedMarkers]);

  useEffect(() => {
    if (tempMarkers.length > 0) {
      getLevels(tempMarkers).then((result: any) => {
        setLevels(result);
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tempMarkers]);

  const getLevels = async (selectedMarkers: any) => {
    let temp: any = [];

    selectedMarkers.forEach((selectedMarker: any) => {
      const levelIds = selectedMarker.students.map((student: IStudent) => {
        return student.levelId;
      });
      temp = [...temp, ...levelIds];
    });

    return await provider.getMany("levels", { ids: temp }).then((result) => {
      return result.data;
    });
  };

  const getItemStyle = () => ({
    margin: "0 0 20px 0",
    border: "1px solid #EAEAEA",
    padding: "5px 8px",
    background: "#FFFFFF",
  });

  const Item = styled.div`
    &:hover {
      box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.08);
    },
  `;

  const getListStyle = () => ({
    background: "#FBFBFB",
    width: "100%",
  });

  return (
    <div style={getListStyle()}>
      {tempMarkers.length > 0}
      {
        <div>
          {tempMarkers.map((item: any, index: any) => (
            <Item style={getItemStyle()}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography
                    className={
                      width <= 1024
                        ? classes.dragContentTitleTextSmallScreen
                        : classes.dragContentTitleText
                    }
                  >
                    {item.blockNumber} {item.street} {item.postalCode}
                  </Typography>
                </Grid>

                <Grid item xs={12}>
                  <Typography variant="body2">
                    Arrive At :{" "}
                    {moment(item.arrivedAt, "HH:mm").format("HH:mm")}
                  </Typography>
                </Grid>

                <Grid item xs={12}>
                  <Typography variant="body2">
                    Remark Drop/Pick Location : {item.remark ?? "-"}
                  </Typography>
                </Grid>

                <Grid item xs={12}>
                  <Divider />
                </Grid>

                <Grid item xs={12} className={classes.studentChipWrapper}>
                  {item.students
                    .sort((a: any, b: any) => a.id - b.id)
                    .map((student: IStudent) => {
                      return (
                        <Chip
                          label={`
                        ${student.locationCode} - 
                        ${_.truncate(
                          `${student.firstName} ${student.lastName}`,
                          {
                            length: 15,
                          }
                        )} - ${
                            levels.length > 0 &&
                            _.find(levels, ["id", student.levelId])?.name
                          }`}
                          className={classes.studentChip}
                        />
                      );
                    })}
                </Grid>
              </Grid>
            </Item>
          ))}
        </div>
      }
    </div>
  );
};

export default LocationListComponent;
